import { Injectable, NgZone } from '@angular/core';
import { Geolocation, PositionOptions } from '@capacitor/geolocation';
import { CoordinatesModel } from '../../core/models';


export const DEFAULT_COORDINATES = {
  latitude: 0,
  longitude: 0
};

/**
 * Android 12+ treats this as a request for precise location (ACCESS_FINE_LOCATION).
 * Without it the plugin only asks for approximate location, and a network fix often
 * times out — the map then has no coordinates to draw.
 */
export const PRECISE_LOCATION_OPTIONS: PositionOptions = {
  enableHighAccuracy: true,
  timeout: 20000,
  maximumAge: 10000,
};

@Injectable({
  providedIn: 'root'
})
export class GeoLocationService {

  watchId = '';

  constructor(
    private zone: NgZone,
  ) {
  }

  /**
   * Retrieves the current coordinates of the device.
   *
   * @returns A promise that resolves to an object containing the latitude and longitude of the current location.
   * If an error occurs, the promise will resolve to the default coordinates specified in the DEFAULT_COORDINATES constant.
   */
  async getCurrentPosition(): Promise<CoordinatesModel> {
    try {
      const currentPosition = await Geolocation.getCurrentPosition(PRECISE_LOCATION_OPTIONS);
      return {
        latitude: currentPosition.coords.latitude,
        longitude: currentPosition.coords.longitude
      };
    } catch (error) {
      console.log('location Error:', error);
      return DEFAULT_COORDINATES;
    }
  }

  /**
   * Watches the current position of the device and returns a promise that resolves to the updated coordinates.
   *
   * @returns A promise that resolves to an object containing the updated latitude and longitude of the current location.
   * If an error occurs, the promise will resolve to the default coordinates specified in the DEFAULT_COORDINATES constant.
   */
  async watchCurrentPosition(): Promise<CoordinatesModel> {
    try {
      return new Promise(async (resolve) => {
        this.watchId = await Geolocation.watchPosition(PRECISE_LOCATION_OPTIONS, (currentPosition, error) =>
          this.zone.run(() => {
            let currentCoordinates = DEFAULT_COORDINATES;
            if (error) {
              console.log('inside watchPosition() ERROR state', error);
              resolve(currentCoordinates);
            }
            if (currentPosition) {
              console.log('currentPosition', currentPosition);
              currentCoordinates = {
                latitude: currentPosition.coords.latitude,
                longitude: currentPosition.coords.longitude
              };
            }
            this.clearWatch();
            resolve(currentCoordinates);
          }
          ));
      });
    } catch (error) {
      console.log('inside watchCurrentPosition() catch ERROR state', error);
      return Promise.resolve(DEFAULT_COORDINATES);
    }
  }

  /**
   * Clears the current position watch.
   *
   * @returns
   */
  clearWatch(): void {
    console.log('inside clearwatch()', this.watchId);
    if (this.watchId != null) {
      Geolocation.clearWatch({ id: this.watchId });
    }
  }
}
